import { Component } from '@angular/core';

/**
 * Generated class for the LogoComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'logo',
  templateUrl: 'logo.html'
})
export class LogoComponent {

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/components/logo/logo.ts